export default __webpack_public_path__ + "static/media/gil-rabbi.9fef15e2.jpg";